import React, { useState, useEffect, useRef } from "react";
import { AutoComplete } from "primereact/autocomplete";
// API base path from environment variable, defaults to empty string for relative paths
const API_BASE_PATH = process.env.REACT_APP_RESOAPI_BASE_URL || "";
const WEBAPI_BASE_PATH = process.env.REACT_APP_WEBAPI_BASE_URL || "";

const CitySearch = ({
  value = "",
  onChange,
  onSelect,
  onClear,
  placeholder = "Enter City",
  className = "w-100",
  inputStyle = { width: "100%", border: "none" },
  disabled = false,
  showClearButton = true,
}) => {
  const [inputValue, setInputValue] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const containerRef = useRef(null);
  const [panelWidth, setPanelWidth] = useState("auto");

  // Update input value when external value changes
  useEffect(() => {
    if (value) {
      setInputValue(value?.label || value || "");
    }
  }, [value]);

  // Update panel width to match container width
  useEffect(() => {
    const updatePanelWidth = () => {
      if (containerRef.current) {
        const width = containerRef.current.offsetWidth;
        setPanelWidth(`${width}px`);
      }
    };
    
    updatePanelWidth();
    window.addEventListener('resize', updatePanelWidth);
    
    return () => {
      window.removeEventListener('resize', updatePanelWidth);
    };
  }, []);

  const autocompletesearch = async (event) => {
    const query = encodeURIComponent(event.query || "");
    const url = `${API_BASE_PATH}/Api/Search/AutoCompleteSearchText?txt=${query}&buyorrent=0&getLocationType=&notConsidering=&considerCityforCounties=`;

    try {
      const response = await fetch(url);
      if (!response.ok) {
        setSuggestions([]);
        return;
      }
      const data = await response.json();
      const formattedSuggestions = (data || []).map((item) => {
        const arr = item.split("/");
        if (arr[1] === "clear") {
          return { label: arr[0], value: null, header: true };
        }
        return { label: arr[0], value: arr[1] };
      });
      setSuggestions(formattedSuggestions);
    } catch (err) {
      setSuggestions([]);
    }
  };

  const handleChange = (e) => {
    setInputValue(e.value || "");
    if (onChange) {
      onChange(e.value || "");
    }
  };

  const handleSelect = (e) => {
    if (e.value && !e.value.header) {
      const cityLabel = e.value.label || e.value;
      setInputValue(cityLabel);
      
      // Dispatch city change event
      if (cityLabel) {
        window.dispatchEvent(new CustomEvent("searchCityChanged", { detail: { city: cityLabel } }));
        localStorage.setItem("searchCity", cityLabel);
      }
      
      if (onSelect) {
        onSelect(e.value);
      }
    }
  };

  const itemTemplate = (item) => {
    if (item.header) {
      return (
        <div
          style={{
            fontWeight: "bold",
            color: "#888",
            pointerEvents: "none",
            background: "#f8f9fa",
          }}
        >
          {item.label}
        </div>
      );
    }
    return <div>{item.label}</div>;
  };

  const handleClear = () => {
    setInputValue("");
    
    // Dispatch city change event for clear
    window.dispatchEvent(new CustomEvent("searchCityChanged", { detail: { city: "" } }));
    localStorage.removeItem("searchCity");
    
    if (onClear) {
      onClear();
    }
    if (onChange) {
      onChange("");
    }
  };

  const containerStyle = {
    border: "1px solid #ced4da",
    borderRadius: "25px",
    backgroundColor: "#fff",
    display: "flex",
    alignItems: "center",
    padding: "5px 15px",
  };

  return (
    <div ref={containerRef} className="city-search-component search-bar" style={containerStyle}>
      <AutoComplete
        inputId="citysearch"
        className={className}
        inputStyle={inputStyle}
        placeholder={placeholder}
        value={inputValue}
        suggestions={suggestions}
        completeMethod={autocompletesearch}
        onChange={handleChange}
        onSelect={handleSelect}
        field="label"
        itemTemplate={itemTemplate}
        disabled={disabled}
        panelStyle={{ width: panelWidth, maxWidth: panelWidth }}
        panelClassName="city-search-panel"
      />
      {showClearButton && inputValue && (
        <div className="closeBtn">
          <img
            src={require("../assets/image/web-img/cross-icon-btn.png")}
            style={{ height: "40px", cursor: "pointer" }}
            alt="Clear"
            onClick={handleClear}
          />
        </div>
      )}
    </div>
  );
};

export default CitySearch;
